import Service from "../Service";

const resource = "ContainerMovement/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    getDetails(cmvID, requestID) {
        return Service.get(resource + "details/" + cmvID, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    registerReturn(obj, requestID) {
        return Service.post(resource + "registerReturn", obj, {
            params: { requestID: requestID },
        });
    },
    cancelReturn(obj, requestID) {
        return Service.post(resource + "cancelReturn", obj, {
            params: { requestID: requestID },
        });
    }
};
